import React, { createContext, useContext, useRef } from 'react'
import { animate } from 'motion/react'

interface SectionInteractionContextType {
  registerRef: (key: string, node: HTMLElement | null) => void
  scrollTo: (key: string) => void
}

const SectionInteractionContext = createContext<SectionInteractionContextType | undefined>(undefined)

export const SectionInteractionProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const sectionRefs = useRef<Record<string, HTMLElement | null>>({})

  const registerRef = (key: string, node: HTMLElement | null) => {
    sectionRefs.current[key] = node
  }

  const scrollTo = (key: string) => {
    const node = sectionRefs.current[key]
    if (node) {
      node.scrollIntoView({ behavior: 'smooth', block: 'center' })

      animate(node, { opacity: [0, 1, 0] }, { duration: 1, ease: 'easeInOut' })
    }
  }

  return (
    <SectionInteractionContext.Provider value={{ registerRef, scrollTo }}>
      {children}
    </SectionInteractionContext.Provider>
  )
}

export const useSectionInteraction = () => {
  const context = useContext(SectionInteractionContext)
  if (!context) {
    throw new Error('useSectionInteraction must be used within a SectionInteractionProvider')
  }
  return context
}
